<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div>



<div class="columns is-multiline is-gapless colBorder  has-background-white">


<div class="column is-2">   
    <div class="columns is-multiline is-gapless">      
        <div class="column is-12 has-text-weight-bold is-uppercase">&nbsp;{{studGrp.student_lNAME}}</div>
        <div class="column is-12 is-size-7 is-uppercase" style="margin-top:-.5em;">&nbsp; {{studGrp.student_fNAME}}</div>
        
    </div>
</div>

<div class="column is-2">   
    <div class="columns is-multiline is-gapless">      
        <div class="column is-12 has-text-weight-bold has-text-centered" style=""> {{studGrp.student_GRPCODE}}&nbsp;</div>
        <div class="column is-12 is-size-7 is-uppercase has-text-centered" style="margin-top:-.5em;">&nbsp; {{studGrp.student_CodePerm}}</div>
        
    </div>
</div>

<div class="column is-2">   
    <div class="columns is-multiline is-gapless">      
        <div class="column is-12 has-text-weight-bold has-text-centered" style=""> {{studGrp.student_CreateDate | moment("MMM DD YY")}}&nbsp;</div>
        <!-- <div class="column is-12 is-size-7 is-uppercase has-text-centered" style="margin-top:-.5em;">&nbsp; {{stud.student_CodePerm}}</div> -->
        
    </div>
</div>
<!-- END 6  v-if="tran_status_icr == 'PENDING'" -->

        <!-- <a class="button is-fullwidth" :class="return_style_button_icr()">
            <span v-if="tran_status_icr=='NEED'" class="icon is-small"><i class="fas fa-plus-circle fa-lg"></i></span>
            <span v-else-if="tran_status_icr=='GOT'" class="icon is-small"><i class="fas fa-thumbs-up fa-lg"></i></span>
            <span v-else-if="tran_status_icr=='PENDING'" class="icon is-small"><i class="fas fa-clock fa-lg"></i></span>
            <span v-else-if="tran_status_icr=='ERROR'" class="icon is-small"><i class="fas fa-exclamation-triangle fa-lg"></i></span>
            <span v-else class="icon is-small"><i class="fas fa-plane-departure fa-lg"></i></span>
        </a> -->



<div class="column is-3"> 
<div class="columns is-centered is-gapless">
    <div class="column is-4" @click="clicked_icr()"> 
        <a v-if="tran_status_icr=='NEED'" class="button is-fullwidth" :class="return_style_button_icr()">
            <span class="icon is-small"><i class="fas fa-plus-circle fa-lg"></i></span>
        </a> 
        <a v-else-if="tran_status_icr=='GOT'" class="button is-fullwidth" :class="return_style_button_icr()">
            <span class="icon is-small"><i class="fas fa-thumbs-up fa-lg"></i></span>
        </a>
        <a v-else-if="tran_status_icr=='PENDING'" class="button is-fullwidth" :class="return_style_button_icr()">
            <span class="icon is-small"><i class="fas fa-clock fa-lg"></i></span>
        </a>
        <a v-else-if="tran_status_icr=='ERROR'" class="button is-fullwidth" :class="return_style_button_icr()">
            <span class="icon is-small"><i class="fas fa-exclamation-triangle fa-lg"></i></span>
        </a>
        <a v-else class="button is-fullwidth" :class="return_style_button_icr()">
            <span class="icon is-small"><i class="fas fa-plane-departure fa-lg"></i></span>
        </a> 
    </div>      
</div></div>




    <!-- <div class="column is-3">   
    <div v-if="is_selected_icr" class="columns is-gapless">    
        <div class="column is-12"> <a class="button is-fullwidth has-background-grey-lighter has-text-info" @click="clicked_cancel_icr('ICR')"><span class="icon is-small"><i class="fas fa-undo"></i></span></a> </div>
    </div>

    <div v-else class="columns is-gapless">    
        <div v-if="tran_status_icr == 'PENDING'" class="column is-12"> <a class="button is-fullwidth has-background-warning has-text-black" @click="clicked_icr('ICR','C')"><span class="icon is-small"><i class="fas fa-user-times"></i></span></a> </div>      
        <div v-else-if="tran_status_icr == 'NEED'" class="column is-12"> <a class="button is-fullwidth has-background-white has-text-success" @click="clicked_icr('ICR','C')"><span class="icon is-small"><i class="fas fa-plus-circle"></i></span></a> </div>
        <div v-else-if="tran_status_icr == 'ERROR'" class="column is-12 showhim"> <a class="button is-fullwidth has-background-danger-light has-text-success" @click="clicked_icr('ICR','C')"><span class="icon is-small"><i class="fas fa-plus-circle"></i></span></a> 
                <div class="column is-12 showme colNotes is-size-7 has-text-weight-bold">{{tran_error_icr}}</div>
        </div> 
        <div v-else class="column is-12"><div class="columns is-gapless">
            
            <div class="column is-12"> <a class="button is-fullwidth has-background-white has-text-danger" @click="clicked_icr('ICR','A')"><span class="icon is-small"><i class="fas fa-user-times"></i></span></a> </div>
        </div></div>
    </div>

</div> -->
  
<!-- END 3  -->


<div class="column is-3"> 
<div class="columns is-centered is-gapless mt-1">
    <div v-if="tran_status_rcs == 'NEED'" class="column is-4"> 
        <a class="button is-small is-fullwidth has-background-light has-text-success" @click="clicked_rcs('C')"><span class="icon is-small"><i class="fas fa-plus-circle fa-lg"></i></span></a> 
    </div>      
</div></div>



<div v-if="tran_status_icr == 'ERROR' || tran_status_rcs == 'ERROR'" class="column is-12 colNotes">
    {{ this.tran_error_icr}}  {{tran_error_rcs}}
</div>





<!-- <div class="column is-3">   

<div v-if="is_selected_rcs" class="columns is-gapless">    
    <div class="column is-12"> <a class="button is-fullwidth has-background-grey-lighter has-text-info" @click="clicked_cancel_rcs('RCS')"><span class="icon is-small"><i class="fas fa-undo"></i></span></a> </div>
</div>
<div v-else class="columns is-gapless">   
<div v-if="tran_status_rcs == 'PENDING'" class="column is-12"> <a class="button is-fullwidth has-background-warning has-text-black" @click="clicked_rcs('C')"><span class="icon is-small"><i class="fas fa-user-times"></i></span></a> </div>        
<div v-else-if="tran_status_rcs == 'NEED'" class="column is-12"> <a class="button is-fullwidth has-background-white	 has-text-success" @click="clicked_rcs('C')"><span class="icon is-small"><i class="fas fa-plus-circle"></i></span></a> </div>
<div v-else-if="tran_status_rcs == 'ERROR'" class="column is-12 showhim"> <a class="button is-fullwidth has-background-danger-light	 has-text-success" @click="clicked_rcs('C')"><span class="icon is-small"><i class="fas fa-plus-circle"></i></span></a> 
    <div class="column is-12 showme colNotes is-size-7 has-text-weight-bold">{{tran_error_rcs}}</div>
</div>
<div v-else class="column is-12"><div class="columns is-gapless">
    <div class="column is-6"> <a class="button is-fullwidth has-background-white has-background-white has-text-black" @click="clicked_rcs('M')"><span class="icon is-small"><i class="fas fa-edit"></i></span></a> </div>
    <div class="column is-6"> <a class="button is-fullwidth has-background-white has-background-white has-text-danger" @click="clicked_rcs('A')"><span class="icon is-small"><i class="fas fa-user-times"></i></span></a> </div>
</div></div>

</div>
</div>  -->

            
</div>
</div>
</template>

<script>
import axios from 'axios';
//, 'sess', 'ann'
export default {
        props: [ 'studGrp', 'files' , 'selected_icr', 'selected_rcs'],
        components: {  },

        data() {
            return {
                 isLoading:false,

                tran_status_icr_original:'',
                tran_status_icr:'',
                tran_icr_id : '',


                 tran_status_rcs:'',

                 tran_error_icr:'',
                 tran_error_rcs:'',

                 is_selected_icr:this.selected_icr,
                 is_selected_rcs:this.selected_rcs,
                 
            }
        },

created() {

    this.chk_Tran_ICR()
    this.chk_Tran_RCS()


}, // END CREATED

methods : {
 
return_style_button_icr:function() {

    if (this.tran_status_icr == 'CREATE')
    {return 'has-background-success has-text-white'}

    if (this.tran_status_icr == 'PENDING')
    {return 'has-background-dark has-text-warning'}

    if (this.tran_status_icr == 'CANCEL')
    {return 'has-background-danger has-text-white'}

    if (this.tran_status_icr == 'GOT')
    {return 'has-background-dark has-text-white'}


},

// GENERATE ID FOR TRANSACTION -- SAVE TO DB (NEW) 
randomTran_ID:function() {
return 'xxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},

clicked_icr:function() {

    var operation = ''

    // CHECK IF RE-CLICKING
    if (this.is_selected_icr == true) {
        this.tran_status_icr = this.tran_status_icr_original
        this.is_selected_icr = false
        this.$emit('emit_student_grp_click_cancel', this.tran_icr_id);
        return;
    }

    this.tran_icr_id = 'ICR' + this.randomTran_ID()

    if (this.tran_status_icr == 'NEED') {operation = 'C' ; this.tran_status_icr = 'CREATE'}
    if (this.tran_status_icr == 'GOT') {operation = 'A' ; this.tran_status_icr = 'CANCEL'}
    if (this.tran_status_icr == 'PENDING') {operation = 'A' ; this.tran_status_icr = 'CANCEL'}
    if (this.tran_status_icr == 'ERROR') {operation = 'C' ; this.tran_status_icr = 'CREATE'}


    this.is_selected_icr = true 
    this.$emit('emit_student_grp_click', this.studGrp, 'ICR', operation, this.tran_icr_id);

},


clicked_rcs:function(operation) {
    this.is_selected_rcs = true 
    this.$emit('emit_student_grp_click', this.studGrp , 'RCS', operation);
},
clicked_cancel_icr:function(tranType) {
    this.is_selected_icr = false 
    this.$emit('emit_student_grp_click_cancel', this.studGrp.studID, this.studGrp.grpID, tranType);
},
clicked_cancel_rcs:function(tranType) {
    this.is_selected_rcs = false 
    this.$emit('emit_student_grp_click_cancel', this.studGrp.studID, this.studGrp.grpID, tranType);
},



chk_Tran_ICR:function() {
// NEED TO CHECK ALL SENT FOR THIS STUD/GRP/TYPE
    const filter_grp = this.files.filter((x) => x.group_ID === this.studGrp.grpID)
    const filter_stud = filter_grp.filter((x) => x.student_ID === this.studGrp.studID)
    const filter_final = filter_stud.filter((x) => x.tran_TYPE === "ICR")

console.log(filter_final)

    this.tran_status_icr = "NEED" // DEFAULT
    this.tran_status_icr_original = "NEED"

    for (var i = 0; i < filter_final.length; i++) {

        // CHECK IF OUT 
        if (filter_final[i].fileTran_STATUS == 'PENDING') {
            this.tran_status_icr = 'PENDING'
            this.tran_status_icr_original = 'PENDING'
            return
        }


        // CHECK IF OK
        if (!filter_final[i].tran_bERROR) {
            this.tran_status_icr = 'GOT'
            this.tran_status_icr_original = 'GOT'
            return
        }
        // CHECK IF ERROR
        if (filter_final[i].tran_bERROR == true) {
            this.tran_status_icr = 'ERROR'
            this.tran_status_icr_original = 'ERROR' 
            this.tran_error_icr += filter_final[i].tranError_DESC.replace('| ','') + " ---- "
        }
    }
},

chk_Tran_RCS:function() {
// NEED TO CHECK ALL SENT FOR THIS STUD/GRP/TYPE
    const filter_grp = this.files.filter((x) => x.group_ID === this.studGrp.grpID)
    const filter_stud = filter_grp.filter((x) => x.student_ID === this.studGrp.studID)
    const filter_final = filter_stud.filter((x) => x.tran_TYPE === "RCS")
    //console.log(filter_final)

    this.tran_status_rcs = "NEED" // DEFAULT
    for (var i = 0; i < filter_final.length; i++) {

        // CHECK IF OUT 
        if (filter_final[i].fileTran_STATUS == 'PENDING') {
            this.tran_status_rcs = 'PENDING'
            return
        }

        // CHECK IF OK
        if (!filter_final[i].tran_bERROR) {
            this.tran_status_rcs = 'GOT'
            return
        }
        // CHECK IF ERROR
        if (filter_final[i].tran_bERROR == true) {
            this.tran_status_rcs = 'ERROR' 
            this.tran_error_rcs += filter_final[i].tranError_DESC.replace('| ','') + " ---- "
        }
    }
},



chk_Tran_XXXX:function() {

//this.isLoading=true;  

     var index = this.files.findIndex(x => x.student_ID == this.studGrp.studID && x.group_ID == this.studGrp.grpID && x.tran_TYPE == "ICR")
     if (index > -1) { // NEED TO GET WAITING!!!!
            if (this.files[index].tran_bERROR == true) {
            this.tran_status_icr = 'ERROR' 
            this.tran_error_icr = this.files[index].tranError_DESC.replace('| ','')
    } else { 
        this.tran_status_icr = 'GOT'}
    } else {
        // NOT SENT YET
        this.tran_status_icr = 'NEED'
    }

     index = this.files.findIndex(x => x.student_ID == this.studGrp.studID && x.group_ID == this.studGrp.grpID && x.tran_TYPE == "RCS")
     if (index > -1) { // NEED TO GET WAITING!!!!
            if (this.files[index].tran_bERROR == true) {
            this.tran_status_rcs = 'ERROR' 
            this.tran_error_rcs = this.files[index].tranError_DESC.replace('| ','')
    } else { 
        this.tran_status_rcs = 'GOT'}
    } else {
        // NOT SENT YET
        this.tran_status_rcs = 'NEED'
    }

//this.isLoading=false;

},

return_pic:function(pic) {
    return 'https://space-zytco.nyc3.digitaloceanspaces.com/photos/'+pic
},



}, // END METHODS



}
</script>

<style scoped>

.showme {
  display: none;
}

.showhim:hover .showme {
  display: block;
}

</style>